import React from "react";
import { FaSmile, FaFrown, FaMeh } from "react-icons/fa";

const TranscriptionSummary = ({ data = {} }) => {
  const { summarization, sentiment, topics = [] } = data;

  const sentimentIcon = {
    positive: <FaSmile className="text-green-500 text-2xl" />,
    negative: <FaFrown className="text-red-500 text-2xl" />,
    neutral: <FaMeh className="text-gray-500 text-2xl" />,
  };

  const sentimentClass = {
    positive: "bg-green-100 text-green-700",
    negative: "bg-red-100 text-red-700",
    neutral: "bg-gray-100 text-gray-700",
  };

  return (
    <div className="w-full h-72 flex items-center justify-center overflow-y-auto custom-scroll">
      <div className="max-w-lg w-full text-gray-800 dark:text-gray-200 p-4">
        <h2 className="text-2xl font-bold mb-4 text-center">
          AI Summarization
        </h2>
        <p className="text-sm mb-4 text-center">{summarization}</p>

        <div className="flex items-center justify-center mb-4">
          <div className="flex items-center space-x-2">
            {sentimentIcon[sentiment]}
            <span className={`text-sm px-2 py-1 ${sentimentClass[sentiment]}`}>
              {sentiment?.charAt(0).toUpperCase() + sentiment?.slice(1)}
            </span>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2 text-center">Topics</h3>
          <div className="flex flex-wrap justify-center gap-2">
            {topics.map((topic, index) => (
              <span
                key={index}
                className="px-3 py-1 text-sm rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300"
              >
                {topic}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TranscriptionSummary;
